export const formatServicesTypesData = data => {
  return data.map(({ name, id }) => ({ value: id, title: name, key: id }));
};
